export default __webpack_public_path__ + "static/media/Axis of Tartarus.fed13aa9.jpg";